import { resetDistinctId } from '@twlvxtwlv/utils/src/cookie'

export function handleAliasOnLogout() {
  resetDistinctId()
}
